import "./App.css";
import useDisableCopy from "./useDisableCopy";
import Navbar from "./Components/Navbar";
import ReferralRewardBanner from "./Components/ReferralRewardBanner";
import PresaleAnnouncementModal from "./Components/Modals/PresaleAnnouncementModal";
import PresaleFloatingBar from "./Components/Modals/PresaleFloatingBar";
import MainFooter from "./Components/Footer";
import ContactUs from "./Screens/ContactUs";
import Privacy from "./Screens/PrivacyAndPolicy";
import Terms from "./Screens/TermsAndConditions";
import LandingPage from "./Screens/LandingPage";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import RoadMapSection from "./Components/roadMapSection";
import OurTeamSection from "./Components/ourTeamSection";
import { useEffect, useState } from "react";
// import AssetTransparency from "./Screens/AssetTransparency";
// Imported last so its rules win cascade ties against index.css/App.css/
// Modal.css/ReferralRewardBanner.css, all of which are otherwise entangled
// in an import order that isn't guaranteed to put overrides last.
import "./theme-light.css";

const SiteLoadingScreen = () => (
  <div
    className="cosmic-loading-overlay site-loading-overlay"
    role="status"
    aria-live="polite"
    aria-label="Loading 1EYE Chain"
  >
    <div className="cosmic-loading-overlay__content site-loading-overlay__content">
      <span className="site-loading-kicker">Entering the ecosystem</span>
      <span className="cosmic-eye-loader">
        <span className="cosmic-eye-loader__mark" aria-hidden="true">
          <span className="cosmic-eye-loader__orbit" />
          <span className="cosmic-eye-loader__core">1</span>
        </span>
        <span className="cosmic-eye-loader__copy">
          <strong>1EYE</strong>
          <small>Initializing 1EYE Chain</small>
        </span>
      </span>
      <span className="cosmic-loading-overlay__signal" aria-hidden="true" />
    </div>
  </div>
);

function App() {
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [showPresaleAnnouncement, setShowPresaleAnnouncement] = useState(false);
  const [presaleAnnouncementDismissed, setPresaleAnnouncementDismissed] =
    useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useDisableCopy();

  useEffect(() => {
    const previousOverflow = document?.body?.style?.overflow;
    document.body.style.overflow = "hidden";

    const loadingTimer = window?.setTimeout(() => {
      setIsPageLoading(false);
      document.body.style.overflow = previousOverflow;
    }, 2000);
    const announcementTimer = window?.setTimeout(() => {
      setShowPresaleAnnouncement(true);
    }, 2250);

    return () => {
      window.clearTimeout(loadingTimer);
      window.clearTimeout(announcementTimer);
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const handlePresaleParticipation = () => {
    setShowPresaleAnnouncement(false);
    const purchaseActionId = "presale-buy-action";

    if (location.pathname !== "/") {
      navigate(
        { pathname: "/", search: location.search },
        { state: { scrollToId: purchaseActionId } },
      );
      return;
    }

    window.setTimeout(() => {
      const purchaseAction = document?.getElementById(purchaseActionId);
      if (!purchaseAction) return;

      purchaseAction?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 180);
  };

  const handlePresaleAnnouncementClose = () => {
    setShowPresaleAnnouncement(false);
    setPresaleAnnouncementDismissed(true);
  };

  return (
    <>
      {isPageLoading && <SiteLoadingScreen />}
      <PresaleAnnouncementModal
        show={showPresaleAnnouncement}
        onClose={handlePresaleAnnouncementClose}
        onParticipate={handlePresaleParticipation}
      />
      {!isPageLoading &&
        presaleAnnouncementDismissed &&
        !showPresaleAnnouncement && (
          <PresaleFloatingBar onParticipate={handlePresaleParticipation} />
        )}
      <div
        className={`site-shell ${isPageLoading ? "site-shell--loading" : "site-shell--ready"}`}
      >
        <ReferralRewardBanner />
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<LandingPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/roadmap" element={<RoadMapSection />} />
        </Routes>
        <MainFooter />
      </div>
    </>
  );
}

export default App;
